import axios from 'axios';
import * as Minio from 'minio';
import { Modal } from "antd";
import xlsx from 'xlsx'

// ! PRODUCTION MODE
var baseUrl = 'https://arman.dexagroup.com';
var armanUrl = 'https://arman.dexagroup.com';
var oracleUrl = 'https://arman.dexagroup.com';
var tracesUrl = 'https://arman.dexagroup.com';
var financeUrl = 'https://billing.dexagroup.com';
var chdUrl = 'https://arman.dexagroup.com';
let oracle = "http://192.168.3.169:5010/api/v1/oracle/supplier";

// var baseUrl = "http://localhost:31814"
// var armanUrl = "http://localhost:31814"
// var oracleUrl = "http://localhost:31814"
// var tracesUrl = "http://localhost:31814"
// ============================================================================

// ! DEVELOPMENT MODE
// UAT
// var baseUrl = "http://192.168.3.117:5000"
  // process.env.NODE_ENV === "production"
  //   ? "https://dev-infostep.dexagroup.com"
  //   : "http://192.168.3.117:5000";
// var armanUrl ="http://192.168.3.117:5010"
  // process.env.NODE_ENV === "production"
  //   ? "https://dev-infostep.dexagroup.com"
  //   : "http://192.168.3.117:5010";
// var oracleUrl ="http://192.168.3.117:5020"
  // process.env.NODE_ENV === "production"
  //   ? "https://dev-infostep.dexagroup.com"
  //   : "http://192.168.3.117:5020";
// var tracesUrl = "http://192.168.74.212:30211"
  // process.env.NODE_ENV === "production"
  //   ? "https://dev-infostep.dexagroup.com"
  //   : "http://192.168.74.212:30211";
    // : "http://192.168.90.64:8211";
// var financeUrl ="http://192.168.3.117:10315"
  // process.env.NODE_ENV === "production"
  //   ? "https://dev-microservices.dexagroup.com"
  //   : "http://192.168.3.117:10315";
// var chdUrl ="http://192.168.3.117:30317"
  // process.env.NODE_ENV === "production"
  //   ? "http://192.168.3.117:30317"
  //   : "http://192.168.3.117:30317";


const minioClient = new Minio.Client({
  endPoint: 's3.dexagroup.com',
  accessKey: 'aam-traces',
  secretKey: 'BkwJ0bdaNaSPl44tzxwC01Z6nsAM!U',
});

export const tracesDirectUrl = () => {
	return tracesUrl;
};

export const tracesToken = () => {
	let token = window.localStorage.getItem('is_token');
	return token || '';
};

export default {
	get_token: function () {
		let token = window.localStorage.getItem('is_token');
		return token || '';
	},
	getUrlOracle: function () {
		return oracle
	},
	getFinance: function (url, param, callback) {
		axios
			.get(financeUrl + url, param, {
				header: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postInfostep: function (url, param, callback) {
		axios
			.post(baseUrl + url, param, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				let status = e.response && e.response.status ? e.response.status : 500;
				this.handleError(status, callback.error);
			});
	},
	postOracle: function (url, param, callback) {
		axios
			.post(oracleUrl + url, param, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postArman: function (url, param, callback) {
		axios
			.post(armanUrl + url, param, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postTraces: function (url, param, callback) {
		axios
			.post(tracesUrl + url, param, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	putTraces: function (url, param, callback) {
		axios
			.put(tracesUrl + url, param, {
				headers: {
					Authorization: 'Bearer ' + this.get_token(),
				},
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postCHD: function (url, param, callback) {
		axios
			.post(chdUrl + url, param, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postFinance: function (url, param, callback) {
		axios
			.post(financeUrl + url, param, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	handleError: function (status, callback) {
		switch (status) {
			case 401:
				window.location.href = '/login?unauthorize';
				break;
			case 200:
				callback();
				break;
			default:
				callback();
				break;
		}
	},
	getInfostep: function (url, callback) {
		axios
			.get(baseUrl + url, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				let status = e.response && e.response.status ? e.response.status : 500;
				this.handleError(status, callback.error);
			});
	},
	getOracle: function (url, callback) {
		axios
			.get(oracleUrl + url, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				let status = e.response && e.response.status ? e.response.status : 500;
				this.handleError(status, callback.error);
			});
	},
	getArman: function (url, callback) {
		axios
			.get(armanUrl + url, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				let status = e.response && e.response.status ? e.response.status : 500;
				this.handleError(status, callback.error);
			});
	},
	getTraces: function (url, callback) {
		axios
			.get(tracesUrl + url, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				let status = e.response && e.response.status ? e.response.status : 500;
				this.handleError(status, callback.error);
			});
	},
	postnobody: function (url, param, callback) {
		axios
			.post(baseUrl + url, param)
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postnobodyTraces: function (url, param, callback) {
		axios
			.post(tracesUrl + url, param, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postnobodyCHD: function (url, param, callback) {
		axios
			.post(chdUrl + url, param, {
				headers: { Authorization: 'Bearer ' + this.get_token() },
			})
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	postFullUrl: function (url, param, callback) {
		axios
			.post(url, param)
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	getFullUrl: function (url, callback) {
		axios
			.get(url)
			.then((response) => {
				callback.success(response);
			})
			.catch((e) => {
				callback.error(e);
			});
	},
	createPresignedUrl: async (fileName) => {
		try {
			const policy = minioClient.newPostPolicy();
			policy.setKey(fileName);
			policy.setBucket('aam-traces');
			const expires = new Date();
			expires.setSeconds(60); // 60 Seconds
			policy.setExpires(expires);
			return await minioClient.presignedPostPolicy(policy);
		} catch (error) {
			// warning("Failed", "Failed create presign URL");
			Modal.warning({
				title: 'Failed',
				content: 'Failed create presign URL',
				onOk() {
					// setData([]);
				},
			});
		}
	},
	uploadToS3: async (obj, file) => {
		try {
			const formData = new FormData();
			Object.entries(obj.formData).forEach(([key, value]) => {
				formData.append(key, value);
			});
			formData.append('file', file);
			return await axios.post(obj.postURL, formData);
		} catch (error) {
			// this.warning("Failed code : Failed upload to S3 after create presign URL")
			Modal.warning({
				title: 'Failed',
				content: 'Failed code : Failed upload to S3 after create presign URL',
				onOk() {
					// setData([]);
				},
			});
		}
	},
	exportToXlsx: (data, fileName) => {
		const workBook = xlsx.utils.book_new(); // create a new blank book
		const workSheet = xlsx.utils.json_to_sheet(data);
		xlsx.utils.book_append_sheet(workBook, workSheet, 'Sheet1'); // add the worksheet to the book
		xlsx.writeFile(workBook, `${fileName}.xlsx`); // initiate a file download in browser
	},
	getFileS3: function (folder, filename, aliasedFilename = null) {
		try {
			const params = {
				path: folder,
				filename: filename,
			};

			const key = Buffer.from(
				Buffer.from(JSON.stringify(params)).toString('hex')
			).toString('base64');
			const url = tracesUrl + `/api/traces/v1/general/s3/${key}/${aliasedFilename ? aliasedFilename : filename}`;
			return url;
		} catch (error) {
			return error.message;
		}
	},
	downloadXlsxDateFormat: function (data, fileName) {
		const workBook = xlsx.utils.book_new();
		const workSheet = xlsx.utils.json_to_sheet(data, {
			dateNF: "DD MMM YYYY",
			cellDates: true,
		});
		xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1");
		xlsx.writeFile(
			workBook,
			fileName,
			{ cellDates: true }
		);
	}
};
